import { apiClient } from '../client'
import type { ApiPaginatedResponse, ApiSuccessResponse } from '../../types/api'
import type { NamedRef } from '../../types/case'
import type { Department } from '../../types/department'
import type { NationalHubCase, NationalHubListParams } from '../../types/national-hub'

export type NationalHubFiltersResponse = {
  departments: Department[]
  procedures: NamedRef[]
  comorbidities: NamedRef[]
  complications: NamedRef[]
}

export const nationalHubService = {
  async list(params?: NationalHubListParams) {
    const { data } = await apiClient.get<
      ApiPaginatedResponse<NationalHubCase> | ApiSuccessResponse<NationalHubCase[]>
    >('/national-hub/cases', { params })
    return data
  },

  async show(id: string) {
    const { data } = await apiClient.get<ApiSuccessResponse<NationalHubCase>>(
      `/national-hub/cases/${id}`,
    )
    return data
  },

  async filters() {
    const { data } = await apiClient.get<ApiSuccessResponse<NationalHubFiltersResponse>>(
      '/national-hub/filters',
    )
    return data
  },
}
